import api from "src/api/axios";

const createStore = async (input) => {
  return api.post(`/stores`, input).then((result) => {
    return result.data;
  });
};

const createBulkStore = async (input) => {
  return api.post(`/stores/bulk-create`, input).then((result) => {
    return result.data;
  });
};

const updateStore = async (input, id) => {
  return api.patch(`/stores/${id}`, input).then((result) => {
    return result.data;
  });
};

const updateActiveStatus = async (input, id) => {
  return api.patch(`/stores/active-inactive/${id}`, input).then((result) => {
    return result.data;
  });
};

const getStoreList = async ({
  limit,
  page,
  country = "",
  q = "",
  searchParmas = null,
}) => {
  const params = new URLSearchParams({
    page: page ? page : "1",
    limit: limit ? limit : "10",
  });
  if (country) params.append("country", country);
  if (searchParmas) {
    Object.keys(searchParmas).map((item) => {
      if (searchParmas[item]) {
        params.append(item, searchParmas[item]);
      }
    });
  }
  if (q) params.append("q", q);
  return api.get(`/stores?${params}`).then((result) => {
    return result.data;
  });
};

const getSearchableStoreList = async ({ country }) => {
  const params = new URLSearchParams();
  if (country) params.append("country", country);
  return api.get(`/stores/list?${params}`).then((result) => {
    return result.data;
  });
};

const getNoRouteStores = async ({ country }) => {
  const params = new URLSearchParams();
  if (country) params.append("country", country);
  return api.get(`/stores/no-route-stores?${params}`).then((result) => {
    return result.data;
  });
};

const getSingleStore = async (id) => {
  return api.get(`/stores/${id}`).then((result) => {
    return result.data;
  });
};

export {
  createStore,
  getStoreList,
  getSingleStore,
  updateStore,
  updateActiveStatus,
  createBulkStore,
  getSearchableStoreList,
  getNoRouteStores,
};
